import { render, staticRenderFns } from "./MarkAsDeceased.vue?vue&type=template&id=1828d67f"
import script from "./MarkAsDeceased.vue?vue&type=script&lang=js"
export * from "./MarkAsDeceased.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports